export default {
  get() {
    const context = require.context("../../lang/", true, /\.php$/);
    const obj = {};
    const regex = /(?:\.\/)(.*)(?:\.php)/gm;
    context.keys().forEach(function (key) {

      obj[key.replace(regex, '$1').replace('/', '.')] = context(key);
    });

    return obj;
  }
}
